"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f241 = void 0;
exports.f241 = {
    "ñomndaa": [
        305
    ],
    "ñonda": [
        305,
        603
    ],
    "ñuñ": [
        684
    ],
    "ñañañe": [
        2868
    ],
    "ñuu": [
        8655,
        4624
    ],
    "ñandeva": [
        7667,
        5448
    ],
    "ñiok": [
        5937
    ],
    "ñųhų": [
        5988,
        5995
    ],
    "ñhöñhö": [
        5989
    ],
    "ñatho": [
        5992
    ],
    "ñanagua": [
        7667
    ],
    "ñumí": [
        8656
    ],
    "ñumí mixtec": [
        8656
    ],
    "ñeegatú": [
        8896
    ],
    "ñengatú": [
        8896
    ],
    "ñe’engatú": [
        8896
    ]
};
